<template>
  <main>
    <vue-headful title="ABL Groupe | Architecture & Constructions"/>
    <div class="container">
      <h2>Architecture et Constructions / Architecture and Constructions</h2>
      <section class="box--container">
        <RealisationBox v-for="(realisation, index) in require('../../data/realisations').default" :realisation="realisation"
                       :key="index"/>
      </section>
    </div>
  </main>
</template>

<script>
import RealisationBox from "@/components/RealisationBox";
export default {
  name: "Realisations",
  components: {RealisationBox}
}
</script>

<style scoped>

</style>